import { useQuery } from "@tanstack/react-query";
import {
	GetAuthUserQuery,
	GetAuthUserQueryVariables,
} from "~auth/types/__generated/gql/graphql";
import { gqlReqNext } from "~utils/api/gql-req/next";

const query = /* GraphQL */ `
	query GetAuthUser {
		getCurrentUser {
			id
			createdAt
			updatedAt
			name
			email
			_userGroupMembers {
				userGroupId
			}
		}
	}
`;

export const getAuthUserQueryKey = () => ["getAuthUser"];

const getAuthUserQueryFn = async (signal?: AbortSignal) => {
	return gqlReqNext<GetAuthUserQuery, GetAuthUserQueryVariables>({
		query,
		signal,
	});
};

/**
 * @deprecated Avoid using this directly, access current auth user via AuthContext instead.
 */
export const useGetAuthUser = () => {
	return useQuery({
		queryKey: getAuthUserQueryKey(),
		queryFn: ({ signal }) => getAuthUserQueryFn(signal),
	});
};
